import { useQuery, UseQueryOptions, UseQueryResult } from '@tanstack/react-query';

import { useAuth } from '@modules/auth/hooks';
import { OUTREACH_LOCATIONS_INQUIRY_FORM } from '../constants';
import { getOutreachLocation } from '../services/inquiry-form.service';
import { OutreachLocationResponse } from '../components/CommunityOutreachForm/CommunityOutreachForm.types';

const useQueryOutreachLocations = <TError = unknown,>(
  options?: Omit<
    UseQueryOptions<OutreachLocationResponse[], TError, OutreachLocationResponse[], Array<string | any>>,
    'initialData' | 'queryFn' | 'queryKey'
  >,
): UseQueryResult<OutreachLocationResponse[]> => {
  const { isAuthenticated } = useAuth();

  const enabledOption = options?.enabled !== undefined ? !!options?.enabled : true;

  return useQuery([OUTREACH_LOCATIONS_INQUIRY_FORM], async () => await getOutreachLocation(), {
    ...(options as any),
    enabled: isAuthenticated === true && enabledOption,
  });
};

export default useQueryOutreachLocations;
